import { 
    xesCookie,
    getQuery,
    serializeObject,
    getParamsFromQuery,
    Base64
} from "./xes-lib.js";
import message from "antd/lib/message/index";
import {
  ClassHandler,
  ConfigureHandler,
  HomeworkHandler,
  PlayerHandler,
  CommunityHandler,
  BaizeHandler
} from "./xesEnvHandlers";
import QRCode from "qrcode";
import http from "../../http"
// import { isWdFunction, isIPadAppFunction} from './common'
import xesBridge from 'xes-code-base/lib/libs/xes';
import { XesLoadingState } from "../../reducers/project-state";
const validate = require('scratch-parser');

export const Environment = {
  COMMUNITY: 0,
  HOMEWORK: 1,
  CLASSWORK: 2,
  CONFIGURETOPIC: 3,
  PLAYER: 4,
  BAIZE: 5
}

const LOG_OUT_URL = 'https://login.xueersi.com/newLogin/logout/';
export const getEnv = () => {
  let curEnvironment = getQuery('env')
  if (!curEnvironment) {
    curEnvironment = 'community'
    // 新题库连接仅包含problem_id && paper_version 参数
    if (getQuery('problem_id') && getQuery('paper_version')) {
      curEnvironment = 'xes_syncwork'
    }
  }
  switch (curEnvironment) {
    case 'community':
      return Environment.COMMUNITY
    case 'homework':
      return Environment.HOMEWORK
    case 'classwork':
      return Environment.CLASSWORK
    case 'player':
      return Environment.PLAYER
    case 'configuretopic':
      return Environment.CONFIGURETOPIC
    case 'xes_syncwork':
      return Environment.BAIZE
    default:
      return Environment.COMMUNITY
  }
}
export const xesEnvHandlers = {
  [Environment.HOMEWORK]: HomeworkHandler,
  [Environment.CLASSWORK]: ClassHandler,
  [Environment.CONFIGURETOPIC]: ConfigureHandler,
  [Environment.PLAYER]: PlayerHandler,
  [Environment.COMMUNITY]: CommunityHandler,
  [Environment.BAIZE]: BaizeHandler,
}

let xesEnvHandler = null
export const getXesEnvHanlder = () => {
  if (xesEnvHandler) {
    return xesEnvHandler
  } else {
    try {
      let env = getEnv()
      xesEnvHandler = xesEnvHandlers[env].getInstance() 
      return xesEnvHandler
    } catch (e) {
      return xesEnvHandlers[2].getInstance()
    }
  }
}

export const getWhetherLogin = () => (
  !!xesCookie.getCookie('is_login')
)

export const getProjectData = () => {
  let xesEnvHandler = getXesEnvHanlder()
  return xesEnvHandler.getProjectData()
}

const getTemplateData = () => {
  let xesEnvHandler = getXesEnvHanlder()
  return xesEnvHandler.getTemplateData()
}

export const getMBlockToken = () => {
  let xesEnvHandler = getXesEnvHanlder()
  return xesEnvHandler.getMBlockToken()
}

export const refreshMBlockToken = () => {
  let xesEnvHandler = getXesEnvHanlder()
  return xesEnvHandler.refreshMBlockToken()
}

export const WORK_SPACEPROJECT_ID = 'xes/scratch/WORK_SPACE_PROJECT_ID'
export const IS_TEMPLATE = 2
export const getCountDownTime = () => {
  return parseInt(getQuery('time'))
}

export const genQrCode = (url, id) => {
    QRCode.toCanvas(document.getElementById(id), url)
}

export const genShareUrl = (projectId) => (
  `${window.location.protocol}//code.xueersi.com/course/report-wx?project_type=scratch&project_id=${projectId}`
)

const fromAdapt = getQuery('from') === 'adapt'
const isProjectTemplate = (category) => (category !== 1 || fromAdapt)

let homeworkStatus = {
  PENDING: 1,
  REJECTED: 2,
  RESOLVED: 3
}
const getHomeworkStatus = (status) => {
      // 0 2 6 未提交 4 未改错
      if ([0, 2, 6, 4].includes(status)) {
        return homeworkStatus.REJECTED
      }
      // 1 5待批改
      if ([1, 5].includes(status)) {
        return homeworkStatus.PENDING
      }
      // 3 7已完成
      if ([3, 7].includes(status)) {
        return homeworkStatus.RESOLVED
      }
}
export const isTeacherEnd = () => {
  const ua = window.navigator.userAgent.toLowerCase()
  return (ua.indexOf('xescef') === -1 && ua.indexOf('qtwebengine') > -1) || (/(jzh)/i.test(ua) && /pc\/client/i.test(ua))
}
export const isCorrectEnd = () => {
  const ua = window.navigator.userAgent.toLowerCase()
  return ua.indexOf('homework_correct_app') > -1 || ua.indexOf('homework') > -1 || ua.indexOf('correct') > -1
}
// 降级方案：使用 execCommand
const fallbackCopyTextToClipboard = (text, resolve, reject) => {
  const textArea = document.createElement("textarea");
  textArea.value = text;
  
  // 避免滚动到底部
  textArea.style.top = "0";
  textArea.style.left = "0";
  textArea.style.position = "fixed";
  textArea.style.opacity = "0";
  textArea.style.pointerEvents = "none";
  
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();
  
  try {
      const successful = document.execCommand('copy');
      document.body.removeChild(textArea);
      if (successful) {
          resolve();
      } else {
          reject(new Error('复制失败'));
      }
  } catch (err) {
      document.body.removeChild(textArea);
      reject(err);
  }
};
// 兼容性更好的复制到剪贴板函数
export const copyToClipboard = (text) => {
  return new Promise((resolve, reject) => {
      // 方法1：尝试使用现代的 Clipboard API
      if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(text)
              .then(() => resolve())
              .catch(() => {
                  // 如果失败，降级到传统方法
                  fallbackCopyTextToClipboard(text, resolve, reject);
              });
      } else {
          // 方法2：使用传统的 execCommand 方法
          fallbackCopyTextToClipboard(text, resolve, reject);
      }
  });
};
const gotoLogInPage = () => {
  if (isTeacherEnd() || isCorrectEnd()) {
    // 老师端、批改端不跳转登录页
    return
  }
  const origin = window.location.origin
  if (origin.indexOf('xesv5') < 0) {
    window.open('https://login.xueersi.com/login/aHR0cDovL2NvZGUueHVlZXJzaS5jb20vbG9naW4vY2xvc2U=')
  } else {
    window.open('https://admin.xesv5.com/Index/login')
  }
}
const gotoLogOutPage = () => {
  window.location = `${LOG_OUT_URL}${Base64.encode(window.location.href)}`
}

const getGoldUrl = (answer_result) => {
  let coins = getQuery('goldNum');
  if (!coins) {
      coins = 0;
  }
  let result = answer_result.data.data.result;
  let gold_result = answer_result.gold_result
  if (result !== 'success') {
      coins = Math.ceil(parseInt(coins) / 2);
  }
  let src = 'https://code.xueersi.com' + '/live/messagebox?type=';
  if (gold_result && gold_result.stat === 1) {
      if (result === 'success') {
          if (coins <= 0) {
              src += 'pass_no_gold';
          } else {
              src += 'pass&score=' + coins;
          }
      } else {
          if (answer_result.data.data.data.fail_index === 'no_changes') {
              src += 'nochange';
          } else {
              if (coins <= 0) {
                  src += 'fail_no_gold';
              } else {
                  src += 'fail&score=' + coins;
              }
          }
      }
  } else {
      if (result === 'success') {
          src += 'pass_replay';
      } else {
          src += 'fail_replay';
      }
  }
  return src
}
const getCanBeShare = () => getQuery('needShare') === 'true'

class LibraryManager{
  constructor() {
    this.backdropLibrary = null
    this.spriteLibrary = null
    this.libraryTypes = {
      BACKDROP: 0,
      SPRITE: 1,
      COSTUME: 2,
      SOUND: 3
    }
    this.LibraryHandler = {
      [this.libraryTypes.BACKDROP]: {
        data: null,
        httpHandler: http.getBackdropLibrary
      },
      [this.libraryTypes.SPRITE]: {
        data: null,
        httpHandler: http.getSprites
      },
      [this.libraryTypes.COSTUME]: {
        data: null,
        httpHandler: http.getCostumes
      },
      [this.libraryTypes.SOUND]: {
        data: null,
        httpHandler: http.getSounds
      }
    }
  }
  getLibrary(type) {
    let libraryHandler = this.LibraryHandler[type]
    if (!libraryHandler) {
      throw new Error("资源库类型不存在")
    }
    if (libraryHandler.data === null) {
      return libraryHandler.httpHandler().then(data => {
        libraryHandler.data = data
        return Promise.resolve(data)
      })
    }
    return Promise.resolve(libraryHandler.data)
  }
  getBackdropLibrary() {
    return this.getLibrary(this.libraryTypes.BACKDROP)
  }
  getSpriteLibrary() {
    return this.getLibrary(this.libraryTypes.SPRITE)
  }
  getCostumeLibrary() {
    return this.getLibrary(this.libraryTypes.COSTUME)
  }
  getSoundLibrary() {
    return this.getLibrary(this.libraryTypes.SOUND)
  }
}
const libraryManager = new LibraryManager()

class Platform {
  static isMac() {
  }
  static isIE() {
  }
  static isPadWebkit() {
    return /(jzh|enjoycode)/i.test(navigator.userAgent)
  }
  static isBrowser() {
    return !(xesBridge.isWdFunction() || xesBridge.isIPadAppFunction())
  }
  static isPhone() {
    return /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent) && navigator.platform !== 'iPad'
  } 
  static isIPad() {
    return xesBridge.isIPadAppFunction() || /iPad/i.test(navigator.userAgent)
  }
  static isMobile() {
    return Platform.isPhone() || Platform.isIPad()
  }
  static isHomeworkCorrectApp() { // 移动批改端  业务定
    return /homework_correct_app/i.test(navigator.userAgent)
  }
}

const gotoHomeworkSuccess = () => {
  let liveParams = getParamsFromQuery([
    'liveId',
    'stuId',
    'courseId',
    'stuCouId',
    'workId'
  ])
  let path
  if (Platform.isPadWebkit()) {
    path = `course/padwebkit/submittestsuccess`
  } else {
    path = `course/submittestsuccess`
  }
  let successUrl = `${window.location.origin}/${path}?${serializeObject(liveParams)}`;
  window.parent.location.replace(successUrl)
}

const openPersonalCenter = () => {
  window.open("https://code.xueersi.com/user")
}

const noticeParentWindow = (message, hasPlayerKeyboard) => {
  if (window.parent && typeof window.parent.recieveMessageFromIframe === 'function') {
    window.parent.recieveMessageFromIframe(message, hasPlayerKeyboard)
  }
}
const handleNotLogIn = () => {
  if (Platform.isBrowser()) {
    gotoLogInPage()
  } else {
    window.alert('帐号未登录，请重新登录后再试')
  }
}
const isNeedSaveAssets = (loadingState) => {
  if (getEnv() === Environment.HOMEWORK) {
    if (!getXesEnvHanlder().isHomeworkRejected() && [XesLoadingState.XES_SHARING].includes(loadingState)) {
      return false
    }
  }
  return ![XesLoadingState.XES_CHECKING, XesLoadingState.XES_RESET, XesLoadingState.XES_PUBLISHING].includes(loadingState)
}
const displayException = (message) => {
  alert(message)
}

const validateCode = (code) => {
  return new Promise((resolve, reject) => {
    const codeJSON = JSON.parse(code)
    if (codeJSON.hasOwnProperty('vmJson')) {
      code = JSON.stringify(codeJSON['vmJson'])
    }

    validate(code, false, (error, res) => {
        if (error) {
          message.error('scratch不符合格式');
          return reject(error);
        }
        resolve(res);
    });
  })
}

const hasPlayerKeyboard = () => {
  return Platform.isMobile() && getEnv() === Environment.PLAYER
}

const extractVmJson = (code) => {
  const codeJSON = JSON.parse(code)
  if (codeJSON.hasOwnProperty('vmJson')) {
    return JSON.stringify(codeJSON['vmJson'])
  }
  return code
}
export {
  isProjectTemplate,
  homeworkStatus,
  getHomeworkStatus,
  gotoLogInPage,
  gotoLogOutPage,
  getGoldUrl,
  getCanBeShare,
  gotoHomeworkSuccess,
  getTemplateData,
  libraryManager,
  Platform,
  openPersonalCenter,
  noticeParentWindow,
  handleNotLogIn,
  isNeedSaveAssets,
  displayException,
  validateCode,
  hasPlayerKeyboard,
  extractVmJson
}